import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Paging from '../../component/Paging';
import request from '../../../utils/Request.utils';
import { ToastContainer, toast } from 'react-toastify';
import Modal from '../../component/Modal';

const Faq = ({ isLoggedIn }) => {
  const navigate = useNavigate();
  const [faqs, setFaqs] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currPage, setCurrPage] = useState(1);
  const [totalCnt, setTotalCnt] = useState(0);
  const [loading, setLoading] = useState(true);
  const [selectedFaqs, setSelectedFaqs] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  // 검색
  const [searchQuery, setSearchQuery] = useState('');
  const [inputQuery, setInputQuery] = useState(''); // 입력 필드 상태

  const sortFaqs = (faqs) => {
    return faqs.sort((a, b) => new Date(b.reg_dtm) - new Date(a.reg_dtm));
  };

  const successHandler = useCallback((response) => {
    if (response.messageCode === 200) {
      const sortedFaqs = sortFaqs(response.data.dataList);
      setFaqs(sortedFaqs);
      setTotalPages(response.data.tot_page);
      setTotalCnt(response.data.totalCnt);
      setLoading(false);
    } else {
      toast.error("자주 묻는 질문 정보를 불러올 수 없습니다.");
      setLoading(false);
    }
  }, []);

  const errorHandler = useCallback((error) => {
    toast.error("데이터를 불러오는 중 오류가 발생했습니다.");
    setLoading(false);
  }, []);

  const fetchFaqs = useCallback(() => {
    setLoading(true);
    const params = {
      curr_page: currPage,
      per_page: 10,
      sort_col: 'reg_dtm',
      sort_by: 'desc',
      board_stat: 'all',
      search_query: searchQuery
    };
    request.get("/board/list/admin/BD_FAQ", params, successHandler, errorHandler);
  }, [currPage, searchQuery, successHandler, errorHandler]);

  useEffect(() => {
    fetchFaqs();
  }, [currPage, fetchFaqs]);

  const handlePageChange = (page) => {
    setCurrPage(page);
  };

  const handleSearch = () => {
    setSearchQuery(inputQuery);
  };

  const handleReset = () => {
    setInputQuery('');
    setSearchQuery('');
    setCurrPage(1);
    fetchFaqs();
  };

  const handleSelectFaq = (faqId) => {
    setSelectedFaqs(prevSelectedFaqs =>
      prevSelectedFaqs.includes(faqId)
        ? prevSelectedFaqs.filter(id => id !== faqId)
        : [...prevSelectedFaqs, faqId]
    );
  };

  const handleSelectAll = () => {
    if (selectedFaqs.length === faqs.length) {
      setSelectedFaqs([]);
    } else {
      setSelectedFaqs(faqs.map(faq => faq.board_seq));
    }
  };

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  const handleDelete = async () => {
    try {
      await request.del("/board/BD_FAQ", { board_seqs: selectedFaqs }, () => {
        toast.success("자주 묻는 질문이 성공적으로 삭제되었습니다.");
        fetchFaqs();
        setSelectedFaqs([]);
      }, () => {
        toast.error("자주 묻는 질문 삭제 중 오류가 발생했습니다.");
      });

    } catch (error) {
      console.log(error)
    } finally {
      closeModal();
    }
  };

  return (
    <main>
      <h2 className="adm_com_pg_tit">자주 묻는 질문 목록</h2>
      <div className="adm_com_pg_content">
        <div className="adm_com_board_list__top">
          <div className="adm_com_board_search">
            <div className="adm_com_input_wrap flex_row">
              <select className="select">
                <option value="전체">전체</option>
              </select>
            </div>
            <article className='search end'>
              <select className="select">
                <option value="전체">전체</option>
              </select>
              <input
                type="search"
                value={inputQuery}
                onChange={(e) => setInputQuery(e.target.value)}
                placeholder='검색할 내용을 입력해 주세요.'
                className="input ws type_search"
              />
              <button className="adm_com_btn blue" onClick={handleSearch}>조회</button>
              <button className="adm_com_btn gray" onClick={handleReset}>초기화</button>
            </article>
          </div>
        </div>
        <div className="adm_com_btn_wrap">
          <button className="adm_com_btn gray" onClick={openModal}>선택삭제</button>
          <button onClick={() => navigate("/Manage/Faq/Write")} className="adm_com_btn black">추가</button>
        </div>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <table className='adm_com_board_list'>
            <colgroup>
              <col width="5%" />
              <col width="5%" />
              <col width="50%" />
              <col width="10%" />
              <col width="10%" />
              <col width="10%" />
              <col width="7%" />
              <col width="7%" />
            </colgroup>
            <thead>
              <tr>
                <th>
                  <div className="check">
                    <input
                      type="checkbox"
                      id="chk01"
                      className="adm_com_chk"
                      onChange={handleSelectAll}
                      checked={selectedFaqs.length === faqs.length}
                    />
                    <label htmlFor="chk01" />
                  </div>
                </th>
                <th>번호</th>
                <th>제목</th>
                <th>답변여부</th>
                <th>작성자</th>
                <th>작성일자</th>
                <th>조회수</th>
                <th>관리</th>
              </tr>
            </thead>
            <tbody>
              {faqs.map((faq, index) => (
                <tr key={faq.board_seq}>
                  <td>
                    <div className="check">
                      <input
                        type="checkbox"
                        id={`chk${index + 2}`}
                        className="adm_com_chk"
                        checked={selectedFaqs.includes(faq.board_seq)}
                        onChange={() => handleSelectFaq(faq.board_seq)}
                      />
                      <label htmlFor={`chk${index + 2}`} />
                    </div>
                  </td>
                  <td>{totalCnt - ((currPage - 1) * 10 + index)}</td>
                  <td>{faq.board_title}</td>
                  <td>{faq.board_content2 ? "OK" : ""}</td>
                  <td>{faq.author || '관리자'}</td>
                  <td>{new Date(faq.reg_dtm).toLocaleDateString()}</td>
                  <td>{faq.board_hit}</td>
                  <td>
                    <button onClick={() => navigate(`/Manage/Faq/Write/${faq.board_seq}`)} className="adm_com_btn blue line">수정</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <Paging currentPage={currPage} totalPages={totalPages} onPageChange={handlePageChange} />
      </div>
      <Modal
        open={modalIsOpen}
        close={closeModal}
        type="confirm"
        popSize="s"
        title="삭제 확인"
        description="선택된 자주 묻는 질문을 삭제하시겠습니까?"
      >
        <div className="btn_container">
          <button className="adm_com_btn blue" onClick={handleDelete}>삭제</button>
          <button className="adm_com_btn gray" onClick={closeModal}>취소</button>
        </div>
      </Modal>

      <ToastContainer />
    </main>
  );
};

export default Faq;
